import { createReducer } from "sc/helpers/reducer";
import {
  SETTINGS_LOADED,
  SETTINGS_UPDATE_REQUEST,
  SETTINGS_UPDATE_ERROR,
  SETTINGS_UPDATED,
  SETTINGS_EMAIL_ADD_REQUEST,
  SETTINGS_EMAIL_ADD_ERROR,
  SETTINGS_EMAIL_ADDED,
  SETTINGS_EMAIL_DELETE_REQUEST,
  SETTINGS_EMAIL_DELETE_ERROR,
  SETTINGS_EMAIL_DELETED,
} from "../actions/global-settings";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [SETTINGS_LOADED]: (state, action) => {
    const { emails, ...generalData } = action.payload.globalSettings;
    const emailsWithState = emails.map(email => ({
      value: email,
      deleteInProgress: false,
    }));
    return Object.assign({}, generalData, {
      emails: emailsWithState,
      emailAddInProgress: false,
      generalDataSaveInProgress: false,
    });
  },
  [SETTINGS_UPDATE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: true,
      generalDataError: "",
    }),
  [SETTINGS_UPDATE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
      generalDataError: action.payload.message,
    }),
  [SETTINGS_UPDATED]: (state, action) =>
    Object.assign({}, state, {
      generalDataSaveInProgress: false,
    }),
  [SETTINGS_EMAIL_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: true,
      emailAddError: "",
    }),
  [SETTINGS_EMAIL_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      emailAddInProgress: false,
      emailAddError: action.payload.message,
    }),
  [SETTINGS_EMAIL_ADDED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = [
      ...emails,
      { value: action.payload.email, deleteInProgress: false },
    ];
    return Object.assign({}, generalData, {
      emails: updatedList,
      emailAddInProgress: false,
    });
  },
  [SETTINGS_EMAIL_DELETE_REQUEST]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? true : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [SETTINGS_EMAIL_DELETE_ERROR]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.map(email => ({
      value: email.value,
      deleteInProgress:
        email.value === action.payload.email ? false : email.deleteInProgress,
    }));
    return Object.assign({}, generalData, { emails: updatedList });
  },
  [SETTINGS_EMAIL_DELETED]: (state, action) => {
    const { emails, ...generalData } = state;
    const updatedList = emails.filter(
      email => email.value !== action.payload.email,
    );
    return Object.assign({}, generalData, { emails: updatedList });
  },
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/global-settings-reducer.js